import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

// Named outbound mail credentials — admin-switchable instead of a .env edit
// per container. Mirrors apiCredentials.service.js exactly.
export const mailSendingAccountsList = (params = '') => Http.get(`/mail-sending-accounts${serialize(params)}`)

export const mailSendingAccountCreate = (params = '') => Http.post('/mail-sending-accounts', params)
export const mailSendingAccountByID = (params = '') => Http.get(`/mail-sending-accounts/${params}`)
export const mailSendingAccountUpdate = (params = '') => Http.put(`/mail-sending-accounts/${params.id}`, params)
export const mailSendingAccountDestroy = (params = '') => Http.delete(`/mail-sending-accounts/${params.id}`)

// Makes an account the active sender for its scope.
export const mailSendingAccountActivate = (id) => Http.post(`/mail-sending-accounts/${id}/activate`)

// Connectivity check against the account's own stored credentials — never
// touches what is currently sending.
export const mailSendingAccountTest = (id) => Http.post(`/mail-sending-accounts/${id}/test`)
